
import * as React from "react"

const MOBILE_BREAKPOINT = 768
const TABLET_PORTRAIT_BREAKPOINT = 1024

export function useIsMobile(includeTabletPortrait = false) {
  const [isMobileOrTablet, setIsMobileOrTablet] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Si includeTabletPortrait est true, on détecte aussi les tablettes en mode portrait
    const breakpoint = includeTabletPortrait ? TABLET_PORTRAIT_BREAKPOINT : MOBILE_BREAKPOINT;
    
    // Fonction pour vérifier si c'est une tablette en mode portrait
    const isTabletPortrait = () => {
      if (!includeTabletPortrait) return false;
      
      // Vérifier si c'est une tablette (largeur entre MOBILE_BREAKPOINT et TABLET_PORTRAIT_BREAKPOINT)
      // et que l'orientation est portrait (hauteur > largeur)
      return (
        window.innerWidth >= MOBILE_BREAKPOINT && 
        window.innerWidth < TABLET_PORTRAIT_BREAKPOINT && 
        window.innerHeight > window.innerWidth
      );
    };
    
    const checkDevice = () => {
      setIsMobileOrTablet(window.innerWidth < breakpoint || isTabletPortrait());
    };
    
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    
    // Si on inclut les tablettes en portrait, on doit écouter les changements d'orientation aussi
    if (includeTabletPortrait) {
      window.addEventListener("resize", checkDevice);
    } else {
      mql.addEventListener("change", checkDevice);
    }
    
    checkDevice();
    
    return () => {
      if (includeTabletPortrait) {
        window.removeEventListener("resize", checkDevice);
      } else {
        mql.removeEventListener("change", checkDevice);
      }
    };
  }, [includeTabletPortrait]);

  return !!isMobileOrTablet;
}
